// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"ss_a bhe_b bhe_bj","SubscribedPhotoblogs__link":"ss_b bhe_a bhe_r"};